var _CloseSmall;
import { Fragment, useRef } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import styled from 'styled-components';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import { VIDEO_SPEEDS } from "../../../constants";
import { useHlsContext } from "../../../context/Hls";
import { usePlaybackContext } from "../../../context/Playback";
import { useSubtitleContext } from "../../../context/Subtitle";
import { useUIContext } from "../../../context/UI";
import { useOnWindowClick, useTranslation } from "../../../hooks";
import Submenu from "./Submenu";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-uco3lw-0"
})(["\n  bottom: 0;\n  right: 0;\n  &.is-open {\n    visibility: visible;\n    opacity: 1;\n    transition: opacity 150ms linear;\n  }\n  &.is-closed {\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s 150ms, opacity 150ms linear;\n  }\n  & span,\n  button {\n    user-select: none;\n  }\n"]);
var TabletSheet = function TabletSheet(_ref) {
  var selector = _ref.selector,
    menuId = _ref.menuId,
    onDismiss = _ref.onDismiss,
    onSpeedChange = _ref.onSpeedChange,
    onQualityChange = _ref.onQualityChange,
    onSubtitlesChange = _ref.onSubtitlesChange,
    onAudioChange = _ref.onAudioChange;
  var _usePlaybackContext = usePlaybackContext(),
    currentSpeed = _usePlaybackContext.currentSpeed;
  var _useHlsContext = useHlsContext(),
    qualities = _useHlsContext.qualities,
    currentQuality = _useHlsContext.currentQuality,
    audios = _useHlsContext.audios,
    currentAudio = _useHlsContext.currentAudio;
  var _useSubtitleContext = useSubtitleContext(),
    subtitleOptions = _useSubtitleContext.subtitleOptions,
    currentSubtitleLang = _useSubtitleContext.currentSubtitleLang;
  var _useUIContext = useUIContext(),
    activeMenu = _useUIContext.activeMenu,
    hideSpeedOptions = _useUIContext.hideSpeedOptions;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var containerRef = useRef(null);
  var onWindowClick = function onWindowClick(event) {
    if (activeMenu === menuId) {
      var clickedOnMenu = containerRef.current && containerRef.current.contains(event.target);
      var controlButton = document ? document.querySelector(".cp-".concat(menuId, "-btn-tablet")) : undefined;
      var clickedOnMenuBtn = controlButton && controlButton.contains(event.target);
      if (!clickedOnMenu && !clickedOnMenuBtn) {
        onDismiss();
      }
    }
  };
  useOnWindowClick(onWindowClick);
  var node = document.querySelector(selector);
  if (node) {
    return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsxs(Wrapper, {
      className: cn(activeMenu === menuId ? 'is-open' : 'is-closed', 'absolute bg-base-main-80 flex items-center justify-center w-full h-full z-7'),
      hasQualities: selector === '.cp-player',
      ref: containerRef,
      "data-testid": "cp-menu-tablet-sheet",
      children: [/*#__PURE__*/_jsx("button", {
        type: "button",
        className: "focus:outline-none absolute text-base-lighter top-0 right-0 mt-16 mr-16 z-1",
        onClick: onDismiss,
        "aria-label": t('CLOSE'),
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          size: 24,
          ignoreColor: true,
          className: "fill-current"
        }))
      }), /*#__PURE__*/_jsx("div", {
        className: "flex",
        children: menuId === 'cc' ? /*#__PURE__*/_jsxs(Fragment, {
          children: [subtitleOptions && /*#__PURE__*/_jsx(Submenu, {
            title: t('SUBTITLES'),
            options: subtitleOptions,
            selectedValue: currentSubtitleLang ? currentSubtitleLang.value : undefined,
            onSelect: onSubtitlesChange,
            isCCSubmenu: true
          }), subtitleOptions && !!(audios !== null && audios !== void 0 && audios.length) && /*#__PURE__*/_jsx("div", {
            className: "bg-gray-dark opacity-50 mx-96",
            style: {
              width: '1px'
            }
          }), audios && audios.length > 1 && /*#__PURE__*/_jsx(Submenu, {
            title: t('AUDIO'),
            options: audios,
            selectedValue: currentAudio ? currentAudio.value : undefined,
            onSelect: onAudioChange,
            isCCSubmenu: true
          })]
        }) : /*#__PURE__*/_jsxs(Fragment, {
          children: [qualities && /*#__PURE__*/_jsx(Submenu, {
            title: t('QUALITY'),
            options: qualities,
            selectedValue: currentQuality === null || currentQuality === void 0 ? void 0 : currentQuality.value,
            onSelect: onQualityChange
          }), qualities && !hideSpeedOptions && /*#__PURE__*/_jsx("div", {
            className: "bg-gray-dark opacity-50 mx-96",
            style: {
              width: '1px'
            }
          }), !hideSpeedOptions && /*#__PURE__*/_jsx(Submenu, {
            title: t('SPEED'),
            options: VIDEO_SPEEDS,
            selectedValue: currentSpeed.value,
            onSelect: onSpeedChange,
            isSpeed: true
          })]
        })
      })]
    }), node);
  }
  return null;
};
export default TabletSheet;